export default __webpack_public_path__ + "static/media/pathways.7d5d7796.png";